import { Component } from 'nuxt-property-decorator'
import { BaseVue } from './BaseVue'

@Component
export class ComponentVue extends BaseVue {}
